import { Helmet } from 'react-helmet-async';
import { withRouter, useParams } from 'react-router-dom';
import session from '../../scripts/radresponder.modules.session';
import { useCallback, useEffect, useState } from 'react';
import $ from 'jquery';
import rr from '../../scripts/radresponder';
import toastr from 'toastr';
import MessageProvider from './shared/MessageProvider';
import ValidatedElement from './ValidatedElement';
import PageHeader from './shared/PageHeader';

function ChangeUsername({ history }) {
    const { personnelId } = useParams();
    
    const checkIsSelf = (personnelId, currentUserInfo) => {
        return personnelId && currentUserInfo && personnelId === currentUserInfo.personnelId;
    }
    
    //page header information
    const pageHeaderData = {
        pageHeaderTitle: "Change Username",
        pageHeaderIcon: "fa-user"
    };

    // eslint-disable-next-line
    const [ usernameRequirementsGuidance, setUsernameRequirementsGuidance ] = useState();
    const [ permissions, setPermissions] = useState([]);
    const [ isSaving, setIsSaving ] = useState(false);
    const [ name, setName ] = useState();
    const [ existingUsername, setExistingUsername ] = useState();
    const [ saveSuccessful, setSaveSuccessful ] = useState(false);
    const [ message, setMessage ] = useState();
    const [ isSelf, setIsSelf ] = useState(checkIsSelf(personnelId, session.currentUserInfo()));
    const [ validationError, setValidationError ] = useState();
    const [ isDirty, setIsDirty] = useState(false);
    const [ validationEnabled, setValidationEnabled ] = useState(false); 

    const [ username, setUsername ] = useState();
    const [ confirmationUsername, setConfirmationUsername ] = useState();
    
    const usernameInitialValue = '';
    const confirmationUsernameInitialValue = '';

    session.currentUserInfo.subscribe((val) => {
        setIsSelf(checkIsSelf(personnelId, val));
    });

    //actions
    const save = () => {
        setIsSaving(true);
        setValidationEnabled(true);

        if (validationError){
            console.log(`Validation Error: ${validationError}`);
            setIsSaving(false);
            return;
        }
        else{
            //save the record
            $.post(rr.getApiAddress() + "personnel/changeusername/" + personnelId, "=" + username)
                .done(function () {
                    setSaveSuccessful(true);
                    toastr.success("Your username was changed successfully.");
                    history.goBack();
                })
                .fail(function (jqXhr, textStatus, errorThrown) {
                    toastr.error(rr.extractError(jqXhr, textStatus, errorThrown));
                })
                .always(function () {
                    setIsSaving(false);
                });
        }
    };

    const handleFormChangeTextBox = (initialValue, setPropertyFunction) => {
        return (e) => {
            setIsDirty(e.target.value !== initialValue);
            setPropertyFunction(e.target.value);
        }
    }

    // TODO
    // eslint-disable-next-line
    const validation = () => {
        if (username && confirmationUsername && username !== confirmationUsername){
            return "The username and confirmation username must match";
        }
    }

    //fields
    // self.username = ko.observable().extend({
    //     rateLimit: 400,
    //     required: true,
    //     validation: [{
    //         async: true,
    //         validator: function (val, params, callback) {
    //             if (!val) {
    //                 return;
    //             }
    //             val = val.trim();

    //             var options = {
    //                 url: rr.getApiAddress() + "/account/isusernameunique",
    //                 type: "POST",
    //                 data: { username: val, personnelId: personnelId },
    //                 success: function (data) {
    //                     callback({ isValid: data.isValid, message: data.message });
    //                 }
    //             };

    //             $.ajax(options);
    //         },
    //         message: "Username is required and must be unique"
    //     },
    //     {
    //         async: true,
    //         validator: function (val, params, callback) {
    //             if (!val) {
    //                 return;
    //             }
    //             val = val.trim();

    //             var options = {
    //                 url: rr.getApiAddress() + "/account/isusernamevalidemail",
    //                 type: "POST",
    //                 data: { username: val },
    //                 success: function (data) {
    //                     callback({ isValid: data.isValid, message: data.message });
    //                 }
    //             };

    //             $.ajax(options);
    //         }
    //     },
    //     {
    //         async: true,
    //         validator: function (val, params, callback) {
    //             if (!val) {
    //                 return;
    //             }
    //             val = val.trim();

    //             var options = {
    //                 url: rr.getApiAddress() + "account/isusernamevalid/" + personnelId,
    //                 type: "POST",
    //                 data: "=" + val,
    //                 success: function (data) {
    //                     callback({ isValid: data.isValid, message: data.message });
    //                 }
    //             };

    //             $.ajax(options);

    //         }
    //     }],
    //     reportValidationStatus: true //must be added after validation
    // });




    //validated model
    // eslint-disable-next-line
    const getPayload = () => {
        return {
            Personnel_Id: personnelId,
            Username: username,
            Confirm_Username: confirmationUsername
        }
    };

    const cancel = () => history.goBack();

    //life cycle events
    const activate = useCallback((id, isSelf) => {
        var deferredExecutions = [];

        if (!isSelf) {
            deferredExecutions.push($.post(rr.getApiAddress() + "personnel/getuser/" + id)
                .done(function (d) {
                    setExistingUsername(d.user.username);
                }));
            deferredExecutions.push($.post(rr.getApiAddress() + "personnel/get/" + id)
                .done(function (d) {
                    setName(d.first_Name + " " + d.last_Name);
                }));
        }

        //get security config
        deferredExecutions.push($.get(rr.getApiAddress() + "securityconfig/forperson/" + id)
            .done(function (data) {
                //if user's config doesn't allow cbrnresponder credentials, navigate back
                if (data.Supports_CbrnResponder_Credentials === false) {
                    const ok = "OK";
                    
                    setMessage({
                        message: "The account's organization memberships do not allow for CBRNResponder credential usage or management.",
                        title: "Action is not allowed",
                        options: [ok],
                        setSelectedValue: x => {
                            if (x === ok){
                                history.goBack();
                            }
                        }
                    });
                }
                setUsernameRequirementsGuidance(rr.createUsernameRequirementsFromSecurityConfig(data));
            }));

        return $.when.apply($, deferredExecutions);
    }, [history]);

    const canActivate = useCallback(async (id) => {
        var deferred = $.Deferred();

        //check if user has access to edit username
        return deferred.then(session.getPersonnelPermissions(id)
            .done(function (data) {
                setPermissions(data);
                if (session.hasPermission(permissions, "ChangeUsername")) {
                    deferred.resolve(true);
                } else {
                    deferred.resolve(false);
                }
                return deferred.promise();
            }).fail(function () {
                deferred.resolve(false);
                return deferred.promise();
            }));
    }, [permissions]);

    const canDeactivate = useCallback(async () => {
        if (!saveSuccessful /*&& self.vm().isDirty()*/) {
            const yes = "Yes";
                
            setMessage({
                message: "You have unsaved changes, are you sure you want to leave?",
                title: "Unsaved Changes",
                options: [yes, "No"],
                setSelectedValue: x => {
                    if (x === yes){
                        history.goBack();
                    }
                }
            })
        }
        else {
            return true;
        }
    }, [history, saveSuccessful]);

    const deactivate = useCallback(async() => { }, []);

    const activation = useCallback(async(personnelId, isSelf) => {
        if (await canActivate(personnelId, isSelf)){
            await activate(personnelId);
        }
        else{
            // Handle case when activation is not allowed
        }
    }, [canActivate, activate]);

    const deactivation = useCallback(async() => {
        if (await canDeactivate()){
            await deactivate();
        }
    }, [canDeactivate, deactivate]);

    useEffect(() => {
        activation(personnelId, isSelf);
    }, [personnelId, isSelf, activation]);

    useEffect(() => {
        return () => {
            deactivation();
        }
    }, [deactivation])

    return (
        <>
            <Helmet>
                <title>Change Username | CBRN Network</title>
            </Helmet>
            <div>
                <div className="col-sm-12 col-md-12 col-lg-10 center-column">
                    <PageHeader data={pageHeaderData} />
                    <div data-part="toolbar">
                        <ul className="toolbar-right"></ul>
                    </div>

                    <p>
                        Use the form below to change your username. Required fields are marked with a *.
                        If you have any questions, please contact us at <a href="mailto:support@cbrnresponder.net">support@cbrnresponder.net</a>.
                    </p>

                    <form className="form-horizontal top25">
                        <div className="row">
                            <div className="col-xs-12">
                                <fieldset>
                                    {isSelf ? '' :
                                    <>
                                        <div className="form-group">
                                            <label className="col-md-3 control-label">Name</label>
                                            <div className="col-md-7">
                                                <p className="form-control-static">{name}</p>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-md-3 control-label">Existing Username</label>
                                            <div className="col-md-7">
                                                <p className="form-control-static">{existingUsername}</p>
                                            </div>
                                        </div>
                                    </>
                                    }
                                    <div className="form-group has-feedback">
                                        <label className="col-md-3 control-label required-field-indicator">Username</label>
                                        <div className="col-md-7">
                                            <ValidatedElement validationEnabled={validationEnabled}
                                                setValidationError={setValidationError}
                                                value={username}>
                                                <input type="text" 
                                                    className="form-control" 
                                                    required="required"
                                                    data-required
                                                    autocomplete="off" 
                                                    value={username}
                                                    onChange={handleFormChangeTextBox(usernameInitialValue, setUsername)}
                                                    data-bind="
                                                    popover: {
                                                        placement: 'top',
                                                        title: 'Username Requirements',
                                                        content: $parent.usernameRequirementsGuidance,
                                                        html: true,
                                                        trigger: 'focus',
                                                        customCss: 'max-width-inherit'
                                                    }" />
                                            </ValidatedElement>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label required-field-indicator">Confirm Username</label>
                                        <div className="col-md-7">
                                            <ValidatedElement validationEnabled={validationEnabled} 
                                                setValidationError={setValidationError} 
                                                value={confirmationUsername}>
                                                <input type="text" 
                                                    className="form-control" 
                                                    required="required" 
                                                    data-required
                                                    autocomplete="off" 
                                                    value={confirmationUsername}
                                                    onChange={handleFormChangeTextBox(confirmationUsernameInitialValue, setConfirmationUsername)} />
                                            </ValidatedElement>
                                        </div>
                                    </div>
                                </fieldset>
                                <div className="col-md-offset-3 col-md-7">
                                    <div className="pull-right">
                                        <button className="btn btn-sm btn-success right5" 
                                                onClick={save}
                                                disabled={isSaving || !isDirty}>
                                            <i className="fa fa-regular fa-save right5"></i>{isSaving ? 'Saving...' : 'Save Changes'}
                                        </button>
                                        <button className="btn btn-sm btn-default" 
                                                onClick={cancel} 
                                                disabled={isSaving}>
                                                    <i className="fa fa-solid fa-ban right5"></i>Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <MessageProvider {...message} />
        </>
    );
}

export default withRouter(ChangeUsername);
